import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HeadersTool} from '../tools/headers';

export interface AffairQueryParams {
  selectedAgencies: string;
  selectedProducts: string;
  selectedProductsStatuses: string;
  search: string;
  size: number;
  page: number;
}

@Injectable({
  providedIn: 'root'
})

export class LotsService {

  private route: string = '/units-numbers';

  constructor(
    private http: HttpClient
  ) { }

  public getAll(): Observable<any> {
    return this.http.get(`${environment.apiUrl}${this.route}/list`, {
      headers: HeadersTool.getHeadersWithToken(),
    })
  }

}
